export const MODAL_ACTION = {
  START_LOADING: 'start_loading',
  STOP_LOADING: 'stop_loading',
  GO_OVERVIEW: 'go_overview',
  GO_SUBMISSION_OVERVIEW: 'go_submission_overview',
  DEPOSIT_ANOTHER: 'deposit_another'
};
